module.exports = __webpack_public_path__ + "img/device.ca599a62.svg";